import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
const VARIANTS = {
  PROJECTS: 'projects',
  TEMPLATES: 'templates'
};
const ProjectsError = _ref => {
  let {
    retry,
    projectsCount,
    variant
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require(`../i18n/${locale}.json`);
  });
  const translationKey = variant === VARIANTS.TEMPLATES ? 'TEMPLATES_ERROR_MESSAGE' : 'PROJECTS_ERROR_MESSAGE';
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: [{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 64,
      padding: '0 28px 0 27px'
    }]
  }, /*#__PURE__*/React.createElement(AlertWarningIcon, {
    style: {
      flexShrink: 0
    }
  }), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      paddingLeft: 8
    }]
  }, /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css3: [theme.typography.bodySmall, {
      color: theme.colors.charcoal700,
      paddingRight: 5
    }]
  }, T.translate(translationKey, {
    context: projectsCount
  })), /*#__PURE__*/React.createElement(LinkButton, {
    onClick: retry
  }, /*#__PURE__*/React.createElement(_StyledSpan2, {
    $_css4: [theme.typography.bodySmall]
  }, T.translate('TRY_AGAIN')))));
};
ProjectsError.displayName = 'ProjectsError';
ProjectsError.propTypes = {
  retry: PropTypes.func,
  projectsCount: PropTypes.number,
  variant: PropTypes.oneOf(Object.values(VARIANTS))
};
export default Object.assign(ProjectsError, {
  VARIANTS
});
var _StyledDiv = _styled("div")`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div")`${p => p.$_css2}`;
var _StyledSpan = _styled3("span")`${p => p.$_css3}`;
var _StyledSpan2 = _styled4("span").withConfig({
  displayName: "ProjectsError___StyledSpan2",
  componentId: "sc-1oy79ik-0"
})(["", ""], p => p.$_css4);
//# sourceMappingURL=ProjectsError.js.map